import React from 'react'
import EChartsReact from 'echarts-for-react';
function Box() {
    const option = {
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          data: ['A', 'B', 'C', 'D', 'E'],  // 类目标签
          axisLabel: {
            color: '#000',
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#000',
          },
        },
        series: [
          {
            name: 'Boxplot',
            type: 'boxplot',
            data: [
              // 每个数组分别为一个类目的数据，格式为：[最小值, 第一四分位数, 中位数, 第三四分位数, 最大值]
              [5, 15, 25, 35, 45],
              [10, 20, 30, 40, 50],
              [15, 25, 35, 45, 55],
              [20, 30, 40, 50, 60],
              [25, 35, 45, 55, 65],
            ],
            itemStyle: {
              color: '#1B998B',  // 设置箱体颜色为绿色
            },
            tooltip: {
              formatter: function (params) {
                return (
                  'Min: ' +
                  params.value[0] +
                  '<br>' +
                  'Q1: ' +
                  params.value[1] +
                  '<br>' +
                  'Median: ' +
                  params.value[2] +
                  '<br>' +
                  'Q3: ' +
                  params.value[3] +
                  '<br>' +
                  'Max: ' +
                  params.value[4]
                );
              },
            },
          },
        ],
      };
    
  return (
  <div style={{width: '48%', height: '400px'}}>
       <EChartsReact option={option} style={{width: '100%', height: '90%'}} />
     </div>
  )
}

export default Box
